import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import CashSalesTable from "../../../components/Table/Sales/CashSales";
import { numberFormatter } from "../../../utils/Formatter/Global";
import { createGraphQLClientWithMiddleware } from "../../../services/graphqlClient";
import {
  CustomerDepositFindUniqueQuery,
  useCustomerDepositFindUniqueQuery,
} from "../../../generated/sales";
import { useParams } from "react-router-dom";

type Props = {
  cdUniqueId?: string;
};

const CashSalesTab = ({ cdUniqueId }: Props) => {
  const { id } = useParams();
  const graphQLClient = createGraphQLClientWithMiddleware("sales");

  const { data, isLoading } =
    useCustomerDepositFindUniqueQuery<CustomerDepositFindUniqueQuery>(
      graphQLClient,
      {
        uniqueInput: {
          id: id ? parseInt(id) : undefined,
        },
      },
      {
        enabled: !!id,
        cacheTime: 0,
      }
    );

  const remainingDepositAmount =
    data?.CustomerDepositFindUnique.remaining_deposit_amount;

  if (isLoading) {
    return (
      <Box
        sx={{
          height: "calc(100dvh - 176px)",
          marginRight: "260px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <CashSalesTable cdUniqueId={cdUniqueId} />
      <Box my={2}>
        <Grid container spacing={1.5}>
          <Grid item xs={12} sm={12} md={7} />
          <Grid item xs={12} sm={12} md={5} justifyContent={"flex-end"}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 3,
                py: 1,
              }}
              bgcolor={"primary.light"}
            >
              <Typography
                color={"primary.main"}
                textAlign={"right"}
                flex={2}
                fontWeight={400}
              >
                จำนวนเงินมัดจำคงเหลือ
              </Typography>
              <Typography
                color={"primary.main"}
                fontWeight={600}
                flex={1}
                mr={2}
                minWidth={150}
                textAlign={"right"}
              >
                {numberFormatter(remainingDepositAmount || 0)}
              </Typography>
              <Typography color={"primary.main"} mr={2}>
                บาท
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default CashSalesTab;
